import React from "react";
import * as Icons from "lucide-react";
import { whyChooseUs, stats } from "../data/mock";

const WhyChooseUs = () => {
  return (
    <section className="section-pad bg-[#0a1f44] relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#3b9dff]/10 blur-3xl" />
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8 relative">
        <div className="text-center mb-14">
          <span className="inline-block bg-white/10 text-[#7dc4ff] font-semibold text-sm px-4 py-1.5 rounded-full">
            Why choose us
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mt-4">
            Why our <span className="text-[#3b9dff]">clients</span> choose us
          </h2>
          <p className="text-slate-300 mt-3 max-w-3xl mx-auto">
            Our expertise in seamless installations and dedication to customer
            satisfaction ensure that you get the best in home and commercial
            technology solutions.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {whyChooseUs.map((w) => {
            const Icon = Icons[w.icon] || Icons.Check;
            return (
              <div
                key={w.title}
                className="group bg-white/5 border border-white/10 rounded-2xl p-7 hover:bg-white/10 hover:-translate-y-1 transition-all duration-300"
              >
                <span className="inline-flex w-12 h-12 rounded-xl bg-[#3b9dff]/20 items-center justify-center mb-4 group-hover:bg-[#3b9dff] transition-colors">
                  <Icon className="w-6 h-6 text-[#7dc4ff] group-hover:text-white transition-colors" />
                </span>
                <h4 className="text-white font-bold text-lg mb-2">{w.title}</h4>
                <p className="text-slate-300 text-sm leading-relaxed">{w.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="grid grid-cols-2 max-w-xl mx-auto gap-6 pt-10 border-t border-white/10">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-3xl md:text-4xl font-extrabold text-[#3b9dff]">
                {s.value}
              </div>
              <div className="text-slate-300 text-sm mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
